import type {
    AddressType,
    MembershipDetails,
    UserAddress,
} from '../../entities/entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from '../../entities/membership/hooks/useRefetchMembershipDetailsMutationOptions';
import { requestBuilder } from '../../http/RequestBuilder';

interface UpsertAddressBody {
    id: string; // For Grove, we only allow updating existing addresses for now.
    userId: string;
    type: AddressType;
    line1: string;
    line2?: string;
    city: string;
    postalCode: string;
    state?: string;
    countryCode: string;
}

const useUpsertAddress = requestBuilder.mutation<
    UserAddress,
    UpsertAddressBody
>({
    endpoint: '/api/admin/address',
    method: 'POST',
});

export const useUpsertAddressAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);

    const { mutateAsync } = useUpsertAddress(refetchMembershipMutationOptions);

    const upsertAddressAsync = async (body: UpsertAddressBody) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertAddressAsync,
    };
};
